document.addEventListener('DOMContentLoaded', function () {

  function updateProductName() {
    const productTitleElement = document.getElementById("product_title");
    const productNameInput = document.getElementById("Product_name");

    if (productTitleElement && productNameInput) {
      const productTitle = productTitleElement.value;
      const variantFieldsets = document.querySelectorAll('fieldset.product-form__input--pill');

      const selectedVariants = Array.from(variantFieldsets).map((fieldset) => {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          const label = document.querySelector(`label[for="${checkedInput.id}"]`);
          if (label) {
            let variantText = label.textContent.trim();
            variantText = variantText.replace(/\s*Variant sold out or unavailable\s*/i, '').trim();
            return variantText;
          }
        }
        return null;
      });

      const selectedVariantNames = selectedVariants.filter(Boolean).join(" | ");
      productNameInput.value = selectedVariantNames
        ? `${productTitle} | ${selectedVariantNames}`
        : productTitle;
    } else {
      console.error("Product title or Product_name element not found");
    }
  }


  function getPreorderIDFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("variant");
  }

  function updatePreorderID() {
    const PreorderIDField = document.getElementById("PreorderID");
    if (PreorderIDField) {
      PreorderIDField.value = getPreorderIDFromURL();
    }
  }

 
  // Listen for changes to variant radio buttons
  document.addEventListener('change', function (event) {
    if (event.target.matches('fieldset.product-form__input--pill input[type="radio"]')) {
      updateProductName();
      updatePreorderID();
    }
  });

  // Initial calls on page load
  updateProductName();
  updatePreorderID();


  const openFormBtn = document.getElementById("openFormBtn");
  const orderForm = document.getElementById("orderForm");

  if (openFormBtn && orderForm) {
    openFormBtn.addEventListener("click", async function () {
      const customerInfoDiv = document.getElementById("customer-info");
      const customerID = customerInfoDiv ? customerInfoDiv.getAttribute("data-customer-id") : null;

      try {
        const response = await fetch(
          `https://draft-order-app-outbackkings-9408a4d7ee83.herokuapp.com/customer?customerID=${customerID}`
        );
        if (response.ok) {
          const customerData = await response.json();
          document.getElementById("customerID").value = customerData.id;

          // Update product name with current variant selections
          updateProductName();
          orderForm.style.display = "block";
        } else {
          console.error("Error fetching customer details:", response.statusText);
          alert("Error fetching customer details");
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
        alert("Error fetching customer details");
      }
    });
  }


  const draftOrderForm = document.getElementById("draftOrderForm");
  if (draftOrderForm) {
    draftOrderForm.addEventListener("submit", async function (event) {
      event.preventDefault();

      const formData = new FormData(event.target);
      const data = {
        customerID: formData.get('customerID'),
        PreorderID: formData.get('PreorderID'),
        quantity: formData.get('quantity'),
        productPrice: formData.get('productPrice'),
        productImage: formData.get('productImage')
      };

      try {
        const response = await fetch(
          "https://draft-order-app-outbackkings-9408a4d7ee83.herokuapp.com/create-draft-order",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );

        if (response.ok) {
          displayThankYouMessage();
        } else {
          alert("Error creating draft order");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Error creating draft order");
      }
    });
  }

  function displayThankYouMessage() {
    const productName = document.getElementById("Product_name").value;
    const quantity = document.getElementById("quantity").value;
    orderForm.innerHTML = `
      <div class="thankyou_preorder">
        <h2>Thank You!</h2>
        <p>Your pre-order request has been submitted successfully.</p>
        <p><strong>Product:</strong> ${productName}</p>
        <p><strong>Quantity:</strong> ${quantity}</p>
        <p>You will receive an email shortly with more details on your order.</p>
      </div>
    `;
  }


  const toggleAccordionBtn = document.getElementById("toggle-accordion-btn");
  if (toggleAccordionBtn) {
    toggleAccordionBtn.addEventListener("click", toggleAccordion);
  }

  function toggleAccordion() {
    const accountContainer = document.getElementById("account-container");
    if (accountContainer) {
      accountContainer.classList.toggle("expanded");
      // Remove "hidden" class if you want the .expanded style to handle visibility
      accountContainer.classList.remove("hidden");
    }
  }


  // Attach the event listeners for the login form
  const loginForm = document.getElementById("login-form");
  if (loginForm) {
    loginForm.addEventListener("submit", handleLogin);
  }

  function handleLogin(event) {
    event.preventDefault();
    const email = document.getElementById("email")?.value;
    const password = document.getElementById("password")?.value;

    if (email && password) {
      fetch("/account/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          "customer[email]": email,
          "customer[password]": password,
        }),
      })
      .then((response) => {
        if (response.ok) {
          location.reload(); // Refresh on successful login
        } else {
          return response.text().then((text) => {
            throw new Error(text);
          });
        }
      })
      .catch((error) => console.error("Error:", error));
    }
  }

  // Attach the event listeners for the create account form
  const createAccountForm = document.getElementById("create-account-form");
  if (createAccountForm) {
    createAccountForm.addEventListener("submit", handleCreateAccount);
  }

  function handleCreateAccount(event) {
    event.preventDefault();
    const email = document.getElementById("create-email")?.value;
    const password = document.getElementById("create-password")?.value;
    const firstName = document.getElementById("create-first-name")?.value;
    const lastName = document.getElementById("create-last-name")?.value;

    if (email && password && firstName && lastName) {
      fetch("/account", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          "customer[email]": email,
          "customer[password]": password,
          "customer[first_name]": firstName,
          "customer[last_name]": lastName,
        }),
      })
      .then((response) => {
        if (response.ok) {
          location.reload(); // Refresh on successful account creation
        } else {
          return response.text().then((text) => {
            throw new Error(text);
          });
        }
      })
      .catch((error) => console.error("Error:", error));
    }
  }


  const createAccountLink = document.getElementById("createAccountLink");
  if (createAccountLink) {
    createAccountLink.addEventListener("click", showCreateAccountForm);
  }

  const showLoginFormBtn = document.getElementById("showLoginFormBtn");
  if (showLoginFormBtn) {
    showLoginFormBtn.addEventListener("click", showLoginForm);
  }

  function showCreateAccountForm() {
    const loginFormContainer = document.getElementById("login-form-container");
    const createAccountFormContainer = document.getElementById("create-account-form-container");

    if (loginFormContainer && createAccountFormContainer) {
      loginFormContainer.style.display = "none";
      createAccountFormContainer.style.display = "block";
    }
  }

  function showLoginForm() {
    const loginFormContainer = document.getElementById("login-form-container");
    const createAccountFormContainer = document.getElementById("create-account-form-container");

    if (loginFormContainer && createAccountFormContainer) {
      loginFormContainer.style.display = "block";
      createAccountFormContainer.style.display = "none";
    }
  }
});

